<template>
  <el-dialog
    class="widget-picker-dialog"
    title="Добавить виджет"
    append-to-body
    :close-on-click-modal="true"
    :visible.sync="show"
    width="640px"
  >
    <div v-if="show" class="widget-picker-grid">
      <div
        v-for="(widgetConfig, widgetKey) in widgets"
        :key="widgetKey"
        class="widget-picker-card"
        @click="select(widgetKey)"
      >
        <div
          class="widget-picker-card-icon"
        >
          <i :class="['fas', widgetConfig.icon || 'fa-cube']"></i>
        </div>
        <div class="widget-picker-card-body">
          <div class="widget-picker-card-name">{{ widgetConfig.showName }}</div>
          <div v-if="widgetConfig.description" class="widget-picker-card-description">
            {{ widgetConfig.description }}
          </div>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="show = false;">Закрыть</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: 'WidgetPickerDialog',
  props: {},
  computed: {
    widgets() {
      return this.$companyConfiguration.home.getWidgets();
    },
  },
  data() {
    return {
      show: false,
    }
  },

  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },

    select(widgetKey) {
      this.$emit('select', widgetKey);
      this.show = false;
    },
  }
}
</script>

<style lang="scss">
@import "@/assets/css/project-variables";
@import "@/components/home/dashboard/_dashboard-design";

.widget-picker-dialog {
  .el-dialog__body {
    padding-top: 10px;
  }

  .widget-picker-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: $dashboard-space-md;
  }

  .widget-picker-card {
    @include dashboard-surface-card;
    display: flex;
    align-items: center;
    gap: $dashboard-space-md;
    padding: $dashboard-space-md;
    border: 1px solid $dashboard-border-color;
    cursor: pointer;
    transition: transform .15s ease, box-shadow .15s ease, border-color .15s ease;

    &:hover {
      border-color: $--color-primary;
      box-shadow: $dashboard-elevation-hover;
      transform: translateY(-1px);
    }
  }

  .widget-picker-card-icon {
    color: $--color-primary;
    background-color: mix(#fff, $--color-primary, 90%);
    flex: 0 0 auto;
    width: 44px;
    height: 44px;
    border-radius: $--border-radius-base;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }

  .widget-picker-card-body {
    min-width: 0;
  }

  .widget-picker-card-name {
    font-weight: 600;
    color: #1f2937;
  }

  .widget-picker-card-description {
    margin-top: 2px;
    font-size: 12px;
    color: $dashboard-text-muted;
    line-height: 1.4;
  }
}
</style>
